// import { Link } from "react-router-dom";
// import { Sparkles, ArrowRight } from "lucide-react";

// export default function Orders() {
//   return (
//     <div>
//       <h1 className="text-3xl font-extrabold text-gray-900">Orders</h1>
//       <p className="text-gray-600 mt-1 mb-6">Live module preview</p>

//       <div className="bg-gray-50 border border-gray-100 rounded-2xl px-6 py-16 flex flex-col items-center text-center">
//         <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center mb-6">
//           <Sparkles className="w-6 h-6 text-white" />
//         </div>

//         <h2 className="text-2xl font-extrabold text-gray-900 mb-4">Orders</h2>

//         <p className="text-gray-500 max-w-xl mb-8">
//           This module is part of the ProtoHub MVP scaffold — data schema,
//           workflows and role permissions are wired. Full UI is being rolled
//           out module-by-module across the next releases.
//         </p>

//         <div className="flex flex-wrap items-center justify-center gap-3">
//           <Link
//             to="/app/dashboard"
//             className="bg-white border border-gray-200 text-gray-900 font-semibold text-sm px-5 py-2.5 rounded-xl hover:bg-gray-100 transition"
//           >
//             Innovator Home
//           </Link>
          
//             <a href="#apic-admin"
//             className="flex items-center gap-2 bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-semibold text-sm px-5 py-2.5 rounded-xl hover:opacity-90 transition"
//           >
//             APIC Admin
//             <ArrowRight className="w-4 h-4" />
//           </a>
//         </div>
//       </div>
//     </div>
//   );
// }




import { useState } from "react";
import { Search } from "lucide-react";
import OrderCard from "../components/modules/orders/OrderCard";
import ordersData from "../data/ordersData";

const filters = ["All", "Awaiting Payment", "In Production", "Quality Inspection", "Delivered"];

export default function Orders() {
  const [query, setQuery] = useState("");
  const [activeFilter, setActiveFilter] = useState("All");

  const filtered = ordersData.filter((o) => {
    const matchesFilter = activeFilter === "All" || o.deliveryStatus === activeFilter;
    const matchesQuery =
      o.projectTitle.toLowerCase().includes(query.toLowerCase()) ||
      o.id.toLowerCase().includes(query.toLowerCase());
    return matchesFilter && matchesQuery;
  });

  const activeCount = ordersData.filter((o) => o.deliveryStatus !== "Delivered").length;
  const totalSpend = ordersData
    .filter((o) => o.paymentStatus === "Paid")
    .reduce((sum, o) => sum + o.amount, 0);

  return (
    <div>
      <h1 className="text-3xl font-extrabold text-gray-900">Orders</h1>
      <p className="text-gray-600 mt-1 mb-6">
        Track payments and delivery status for your confirmed builds.
      </p>

      {/* Summary stats */}
      <div className="grid sm:grid-cols-3 gap-4 mb-6">
        <div className="bg-white border border-gray-100 rounded-2xl p-5">
          <p className="text-xs font-semibold text-gray-400 tracking-wide mb-2">TOTAL ORDERS</p>
          <p className="text-2xl font-extrabold text-gray-900">{ordersData.length}</p>
        </div>
        <div className="bg-white border border-gray-100 rounded-2xl p-5">
          <p className="text-xs font-semibold text-gray-400 tracking-wide mb-2">ACTIVE ORDERS</p>
          <p className="text-2xl font-extrabold text-blue-600">{activeCount}</p>
        </div>
        <div className="bg-white border border-gray-100 rounded-2xl p-5">
          <p className="text-xs font-semibold text-gray-400 tracking-wide mb-2">TOTAL SPEND</p>
          <p className="text-2xl font-extrabold text-gray-900">
            ₹{totalSpend.toLocaleString("en-IN")}
          </p>
        </div>
      </div>

      {/* Search + filters */}
      <div className="bg-white border border-gray-100 rounded-2xl p-4 mb-6">
        <div className="flex items-center gap-2 bg-gray-50 border border-gray-200 rounded-xl px-4 py-2.5 mb-4">
          <Search className="w-4 h-4 text-gray-400" />
          <input
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search by project name or order ID..."
            className="w-full bg-transparent text-sm focus:outline-none"
          />
        </div>

        <div className="flex flex-wrap gap-2">
          {filters.map((f) => {
            const isActive = activeFilter === f;
            return (
              <button
                key={f}
                type="button"
                onClick={() => setActiveFilter(f)}
                className={`text-sm font-medium px-4 py-1.5 rounded-full border transition ${
                  isActive
                    ? "bg-indigo-600 border-indigo-600 text-white"
                    : "bg-white border-gray-200 text-gray-700 hover:border-indigo-300"
                }`}
              >
                {f}
              </button>
            );
          })}
        </div>
      </div>

      {/* List */}
      {filtered.length > 0 ? (
        <div className="space-y-5">
          {filtered.map((o) => (
            <OrderCard key={o.id} order={o} />
          ))}
        </div>
      ) : (
        <div className="h-40 flex items-center justify-center text-gray-400 border border-dashed border-gray-200 rounded-2xl">
          No orders match your search.
        </div>
      )}
    </div>
  );
}